const first = (word: string | undefined): string => word?.charAt(0) ?? ''

/**
 * Workspace initials (legacy navbar `getInitials`, wp/shell §4.16): two words → first letters; three or more → the
 * first two words, skipping a leading "The"; one word → its first two letters; upper-case. An empty or missing label
 * gives `''` (legacy threw on a workspace without a Label, NEW-6).
 */
export function workspaceInitials(label: string | null | undefined): string {
  const words = (label ?? '').trim().split(/\s+/).filter(Boolean)
  const [one, two, three] = words
  if (!one) return ''
  if (words.length > 2) {
    return (one.toLowerCase() === 'the' ? first(two) + first(three) : first(one) + first(two)).toUpperCase()
  }
  if (two) return (first(one) + first(two)).toUpperCase()
  return one.slice(0, 2).toUpperCase()
}

/** A person's initials (legacy `avatarText`): first letters of the first and last name. */
export function personInitials(firstName: string | null | undefined, lastName?: string | null): string {
  return `${first(firstName?.trim())}${first(lastName?.trim())}`.toUpperCase()
}
